// Changement de mot de passe — extrait de l'écran Paramètres.
//
// Sorti dans son propre module pour que l'ancienne version de l'écran et la
// nouvelle (React) s'en servent toutes deux, sans duplication ni divergence.
import Store from "../store.js";
import { toast, modale, fermerModale, brancherOeil } from "../ui.js";
import { LIMITES } from "../securite.js";

/** Changement de mot de passe : l'ancien est toujours redemandé. */
export function changerMotDePasse() {
  const { el } = modale({
    titre: "Changer mon mot de passe",
    corps: `
      <label class="label">Mot de passe actuel
        <input class="champ" id="mdp-ancien" type="password" autocomplete="current-password">
      </label>
      <label class="label">Nouveau mot de passe
        <input class="champ" id="mdp-nouveau" type="password" autocomplete="new-password" placeholder="${LIMITES.motDePasseMin} caractères au minimum">
      </label>
      <label class="label">Répétez le nouveau mot de passe
        <input class="champ" id="mdp-confirme" type="password" autocomplete="new-password">
      </label>`,
    actions: [
      { label: "Annuler" },
      {
        label: "Enregistrer",
        classe: "btn--primaire",
        onClick: async (fond) => {
          const ancien = fond.querySelector("#mdp-ancien").value;
          const nouveau = fond.querySelector("#mdp-nouveau").value;
          const confirme = fond.querySelector("#mdp-confirme").value;
          if (!ancien) return toast("Saisissez votre mot de passe actuel", "erreur");
          if (nouveau !== confirme) return toast("Les deux nouveaux mots de passe diffèrent", "erreur");
          if (nouveau === ancien) return toast("Le nouveau mot de passe doit être différent", "erreur");
          const bouton = fond.querySelector('[data-action="1"]');
          bouton.disabled = true;
          bouton.textContent = "Enregistrement…";
          try {
            await Store.auth.changerMotDePasse(ancien, nouveau);
            fermerModale();
            toast("Mot de passe modifié");
          } catch (e) {
            bouton.disabled = false;
            bouton.textContent = "Enregistrer";
            toast(e.message || "Modification impossible", "erreur");
          }
        },
      },
    ],
  });
  brancherOeil(el);
  el.querySelector("#mdp-ancien").focus();
}
